import React from 'react'
import { Img as ImgBs, ImgProps as ImgPropsBs } from '@bootstrap-styled/v4'
import { LazyLoadImage, LazyLoadImageProps } from 'react-lazy-load-image-component'

// Type definition
export interface ImgProps
    extends ImgPropsBs,
        Omit<LazyLoadImageProps, 'src' | 'alt' | 'placeholder' | 'placeholderSrc'> {
    isLazy?: boolean
    fallbackUrl?: string
}

const Img: React.FC<ImgProps> = ({
    isLazy = false,
    fallbackUrl,
    onError,
    tag = 'img',
    ...props
}) => {
    const {
        effect,
        wrapperClassName,
        wrapperProps,
        afterLoad,
        beforeLoad,
        delayMethod,
        delayTime,
        threshold,
        useIntersectionObserver,
        visibleByDefault,
        scrollPosition,
        ...rest
    } = props

    const lazyProps = {
        effect,
        wrapperClassName,
        wrapperProps,
        afterLoad,
        beforeLoad,
        delayMethod,
        delayTime,
        threshold,
        useIntersectionObserver,
        visibleByDefault,
        scrollPosition
    }

    const handleError = (e: React.SyntheticEvent<HTMLImageElement, Event>): void => {
        if (fallbackUrl) {
            e.currentTarget.src = fallbackUrl
        }

        if (typeof onError === 'function') {
            onError(e)
        }
    }

    const TagImg = isLazy
        ? ({ placeholder, ...attrs }: React.ImgHTMLAttributes<HTMLImageElement>): JSX.Element => (
              <LazyLoadImage placeholderSrc={placeholder} {...lazyProps} {...attrs} />
          )
        : tag

    return <ImgBs tag={TagImg} onError={handleError} {...rest} />
}

export default Img
